<template>
  <div>
    <table class="custom-table responsive-table border-collapse">
      <thead class="font-normal">
        <tr class="shadow-table rounded-lg">
          <th class="checkbox">
            <base-checkbox />
          </th>
          <th>Order Date</th>
          <th>Shipping ID</th>
          <th>3PL</th>
          <th>Consignee</th>
          <th>Total shipping cost</th>
          <th>Order status</th>
          <th>Payment status</th>
          <th v-if="withAction">
            <span class="cursor-pointer">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.7">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                    fill="#383F51" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                    fill="#383F51" />
                </g>
              </svg></span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(transaction, index) in transactions" :key="index" class="shadow-table rounded-lg">
          <td>
            <base-checkbox />
          </td>

          <td>
            {{
              transaction.createdAt
                ? transaction.createdAt.split("T")[0]
                : "N/A"
            }}
            <span class="block w-full opacity-50">{{
              transaction.createdAt
                ? addoneHourToTime(transaction.createdAt)
                : ""
            }}
            </span>
          </td>

          <td>
            {{ shipId(transaction) }}
          </td>

          <td>
            <span>
              {{ driverName(transaction) }}
            </span>
          </td>

          <td>
            {{ consigneeName(transaction) }}
          </td>

          <td>
            {{
              transaction
                ? "₦" + amountFomatter(transaction.totalValue)
                : "N/A"
            }}
          </td>
          <td>
            <span :class="[
              true ? statusBg(transaction ? transaction.payoutStatus : null) : null,
            ]" class="capitalize">{{ transaction ? (transaction.payoutStatus).replace("_", " ") : null }}</span>
          </td>
          <td>
            <span :class="[
              true ? statusBg(transaction.paymentStatus || 'pending') : null,
            ]" class="capitalize">{{ transaction.paymentStatus || "pending" }}</span>
          </td>
          <td v-if="withAction" tabindex="-1" @blur="selectedRowId = null"
            class="table__action-btn cursor-pointer relative">
            <span class="-full flex justify-center" @click="selectedRowId = index">
              <vertical-ellipsis />
            </span>

            <div class="actions" v-if="selectedRowId == index">
              <div class="cursor-pointer hover:bg-gray-100" @click="transactionRoute(transaction.id)">
                <span class="icon"><img alt="" class="mr-1" src="@/assets/images/billing/icon-eye-alt.svg" /></span>
                <span>View</span>
              </div>
              <div
                v-if="transaction.paymentStatus.toLowerCase() != 'paid' && $store.state.authentication.env == 'development'"
                @click="setTransactionCost(transaction)" class="cursor-pointer hover:bg-gray-100">
                <span class="icon"><img alt="" class="mr-1" src="@/assets/images/billing/send_invoice.svg" /></span>
                <span>Make Payment</span>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-if="!transactions.length" class="w-full py-24 flex justify-center">
      <div class="w-auto cursor-pointer">
        <img src="@/assets/images/ondemand/Plain credit card-pana 1.svg" />
        <div @click="
          currentTab == 'card' ? $emit('fundCard') : $emit('fundWallet')
          " class="text-primary-yellow flex items-center justify-center">
          <img src="@/assets/images/icons/add.svg" alt="add icon" class="mr-2" />
          {{ currentTab == "card" ? "Add Card" : "Fund Wallet" }}
        </div>
      </div>
    </div>

    <PaymentModal @close-modal="showPaymentModal = false" :show-modal="showPaymentModal" :total="transactioncost"
      :transactionId="transactionId" :paystackkey="paystackkey" :metadata="metadata" @onCardPayment="onCardPayment" />
  </div>
</template>

<script>
import { userId } from "../../../services/apiConfig";
import PaymentModal from "./modals/TransactionpaymentModal.vue";
import moment from "moment"

export default {
  props: ["transactions", "currentTab", "withAction"],
  components: {
    PaymentModal,
  },
  mounted() {
    console.log("transactions--", this.transactions)
  },
  watch: {
    transaction(val) {
      console.log(val)
    }
  },
  data() {
    return {
      transactioncost: 0,
      showPaymentModal: false,
      showFilterModal: false,
      collectPaymentModal: false,
      selectedRowId: -1,
      shareLinkModal: false,
      totalCost: 0,
      transactionId: null,
      shippingId: "",
      paylink: "",
      email: "",
      payAmount: "",
      paystackkey: "pk_test_d81d41eedf44bac3067b59281f5aec31efc13049",
    };
  },
  computed: {
    metadata() {
      return {
        userId: userId(),
      };
    },

    paymentParams() {
      return {
        paylink: this.paylink,
        email: this.email,
        payAmount: this.payAmount,
      };
    },
  },
  methods: {
    onCardPayment(){
       // code here
    },
    addoneHourToTime(IOStime) {
      // Parse the date string
      let date = moment(IOStime);
      // Add one hour
      date.add(0, 'hour');
      // Format the date to hh:mm:ss
      return date.format('HH:mm:ss');
    },
    shipId(org) {
      const orgName = org?.shipping?.shippingReference ?? 'N/A';
      if (orgName !== 'null') return orgName
      return 'N/A'
    },
    consigneeName(org) {
      const orgName = org?.shipping?.shipmentReceiever[0]?.location?.contactName ?? 'N/A';
      if (orgName !== 'null') return orgName
      return 'N/A'
    },
    driverName(org) {
      const driver = org.driver;
      if (driver) {
        const driverName = `${driver.first_name} ${driver.last_name}`;
        return `${driverName}`;
      }
      return 'N/A'
    }, 

    transactionRoute(val) {
      if (!val) return;
      localStorage.setItem("billing_reciept", "transactions");
      this.$router.push({ name: "BCM_reciept", params: { id: val } });
    },

    setTransactionCost(val) {
      this.transactioncost = val?.totalValue;
      this.showPaymentModal = true;
      this.transactionId = val.id;
    },
    statusBg(val) {
      let bg = "";
      switch (val?.toLowerCase()) {
        case "not paid":
          bg = "text-red-500";
          break;
        case "Delivered":
          bg = "text-teal-500";
          break;
        case "estimate":
          bg = "text-primary-yellow";
          break;
        case "pending":
          bg = "text-black";
          break;
        case "picked up":
          bg = "text-primary-yellow";
          break;
        case "paid":
          bg = "text-teal-500";
          break;
        case "delivered":
          bg = "text-teal-500";
          break;
        default:
          bg = "text-red-500";
          break;
      }
      return bg;
    },
  },
};
</script>

<style lang="scss" scoped>
.actions {
  @apply w-auto absolute right-0 bg-white shadow-md z-10 py-3 px-2;
  min-width: 200px;
}

.actions div {
  @apply flex w-full py-2 px-2 items-center;
}

.icon {
  width: auto;
  padding-right: 5px;
}
</style>
